import { render, staticRenderFns } from "./InvoiceRecords.vue?vue&type=template&id=92e28c38&"
import script from "./InvoiceRecords.js?vue&type=script&lang=js&"
export * from "./InvoiceRecords.js?vue&type=script&lang=js&"
import style0 from "./InvoiceRecords.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports